import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import api from "../../../services/baseUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";

export default function WartaState() {
  const location = useLocation();
  const state = location.state?.state || {};
  const userId = JSON.parse(Cookies.get("wartaUser")).userId;
  const [libraries, setLibraries] = useState([]);
  const [allTowns, setAllTowns] = useState([]); // All towns from backend
  const [townList, setTownList] = useState([]); // Filtered towns based on district
  const [districtList, setDistrictList] = useState([]);
  const [formData, setFormData] = useState({
    libraryId: "0",
    town: "",
    district: "",
    gazetteNumber: "",
    lotNumber: "",
    fileReferenceNumber: "",
    projectName: "",
    others: "",
    publicationDate: "",
  });

  useEffect(() => {
    const initState = async () => {
      try {
        const response = await api.get(
          `api/egazette-documents/librariesByState/${state.id}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data) {
          const filteredLibraries = response.data.library.filter(
            (item) => item.orderId !== null
          );
          const updatedLibraries = [
            { name: "All", libraryId: 0, displayName: "All" },
            ...filteredLibraries,
          ];

          setLibraries(updatedLibraries);
        }
      } catch (error) {
        console.error("Error fetching libraries:", error);
      }
    };

    const fetchDistrictList = async () => {
      try {
        const response = await api.get(
          `/ewarta/districtList?stateId=${state.id}`
        );
        if (response.status === 200) {
          const fullList = response.data;

          // Extract unique districts
          const uniqueDistricts = Array.from(
            new Map(
              fullList.map((lib) => [
                lib.districtId,
                { districtId: lib.districtId, districtName: lib.districtName },
              ])
            ).values()
          );

          setDistrictList(uniqueDistricts); // for district dropdown
          setTownList(fullList); // for town dropdown
          setAllTowns(fullList);
        }
      } catch (err) {
        console.error(err);
      }
    };

    initState();
    fetchDistrictList();
  }, [state.id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "district") {
      const selectedDistrict = districtList.find(
        (d) => d.districtName === value
      );

      const filteredTowns = allTowns.filter(
        (t) => t.districtId === selectedDistrict?.districtId
      );

      setTownList(filteredTowns);

      setFormData((prev) => ({
        ...prev,
        district: value,
        town: "",
      }));
    } else if (name === "town") {
      const selectedTown = allTowns.find((t) => t.townName === value);
      const relatedDistrict = districtList.find(
        (d) => d.districtId === selectedTown?.districtId
      );

      setFormData((prev) => ({
        ...prev,
        town: value,
        district: relatedDistrict?.districtName || "", // Auto-set district
      }));

      // Optional: update filtered towns to match selected district
      const filteredTowns = allTowns.filter(
        (t) => t.districtId === selectedTown?.districtId
      );
      setTownList(filteredTowns);
    } else {
      // Regular update
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async () => {
    // Extract only text inputs (excluding 'library')
    const { libraryId, ...textFields } = formData;

    const filledFieldsCount = Object.values(textFields).filter(
      (value) => value.trim() !== ""
    ).length;

    if (filledFieldsCount < 3) {
      toast.error("Please fill at least 3 text fields before submitting.");
      return;
    }

    // Combine all non-empty input values into a single search query string
    const query = Object.entries(textFields)
      .filter(([key, value]) => value.trim() !== "") // Filter out empty values
      .map(([key, value]) => `${key}: ${value}`) // Format as "name: value"
      .join(" | ");

    // Find the selected library ID
    const selectedLibrary = libraries.find(
      (lib) => lib.libraryId.toString() === libraryId
    );

    const libraryOrState =
      selectedLibrary && selectedLibrary.libraryId === 0
        ? { stateId: state.id }
        : { libraryId: selectedLibrary?.libraryId };

    const payload = {
      type: "content",
      modules: "egazette",
      search: "keyword",
      ...libraryOrState,
      query,
      userId,
    };

    try {
      const response = await api.post("ewarta/request/submit", payload);
      if (response.data?.message === "Search request submit successfully") {
        toast.success(response.data.message);
      }
    } catch (e) {}
  };

  return (
    <div className="wartaState-container">
      <div className="wartaState-header">
        {state?.src && (
          <img
            src={state.src}
            alt={`${state.name || "State"} Logo`}
            className="gallery-image"
          />
        )}
        <h1>Gazette for {state.name || "Unknown State"}</h1>
      </div>
      <div className="gazette-finder-announcement">
        You can now access and retrieve the gazettes as needed. Explore the
        features and enjoy the convenience of quickly purchasing gazettes with
        ease. Happy browsing!
      </div>
      {/* <Search libraries={libraries} /> */}
      <div className="form-container">
        <div className="form-grid">
          {/* Library Dropdown */}
          <div className="form-group">
            <label>Library</label>
            <select
              name="libraryId"
              value={formData.libraryId}
              onChange={handleInputChange}
            >
              {libraries.map((lib) => (
                <option key={lib.libraryId} value={lib.libraryId.toString()}>
                  {lib.displayName}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>District</label>
            <select
              name="district"
              value={formData.district}
              onChange={handleInputChange}
            >
              <option value="">Select One</option>
              {districtList.map((lib) => (
                <option key={lib.districtId} value={lib.districtName}>
                  {lib.districtName}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Town</label>
            <select
              name="town"
              value={formData.town}
              onChange={handleInputChange}
            >
              <option value="">Select One</option>
              {townList.map((lib) => (
                <option key={lib.townId} value={lib.townName}>
                  {lib.townName}
                </option>
              ))}
            </select>
          </div>

          {[
            "gazetteNumber",
            "lotNumber",
            "fileReferenceNumber",
            "projectName",
            "others",
            "publicationDate",
          ].map((field, index, arr) => {
            const isLastOdd = arr.length % 2 === 0 && index === arr.length - 1;
            return (
              <div
                key={index}
                className={`form-group${isLastOdd ? " form-group-center" : ""}`}
              >
                <label>
                  {field
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase())}
                </label>
                <input
                  type={field === "publicationDate" ? "date" : "text"}
                  name={field}
                  value={formData[field]}
                  onChange={handleInputChange}
                />
              </div>
            );
          })}
        </div>
        <button
          type="button"
          className="gazette-finder-btn"
          onClick={handleSubmit}
        >
          Send Request
        </button>
        <div className="warta-finder-disclaimer">
          <i>
            Please fill in at least four (4) fields before submitting your
            request. This is help the admin to perform an accurate search of
            your document.
          </i>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
